export default __webpack_public_path__ + "static/media/Chevrons.5faf1daf.svg";